<template>
  <wo-card :title="$t('general.info')">
    <slot name="actions" slot="actions" />
    <wo-properties mod-bordered mod-horizontal>
      <wo-properties-label><wo-label v-t="'user.displayName'" /></wo-properties-label>
      <wo-properties-value>{{ value.display_name }}</wo-properties-value>
      <template v-if="adminMode">
          <wo-properties-label><wo-label v-t="'user.createdOn'" /></wo-properties-label>
          <wo-properties-value>{{ value.created_on | date }}</wo-properties-value>
          <wo-properties-label><wo-label v-t="'general.status'" /></wo-properties-label>
          <wo-properties-value><user-status-badge :value="value" /></wo-properties-value>
          <wo-properties-label><wo-label v-t="'user.role'" /></wo-properties-label>
          <wo-properties-value><po-display :value="value.role" /></wo-properties-value>
      </template>
      <wo-properties-label><wo-label v-t="'user.company'" /></wo-properties-label>
      <wo-properties-value><po-display :value="value.company" /></wo-properties-value>
      <wo-properties-label><wo-label v-t="'user.language'" /></wo-properties-label>
      <wo-properties-value>
          <wo-pill>{{ value.language }}</wo-pill>
      </wo-properties-value>
    </wo-properties>
  </wo-card>
</template>

<script>

import { User } from '@/model/identity'

import UserStatusBadge from '@/components/identity/UserStatusBadge'

export default {
  components: { UserStatusBadge },
  props: {
    value: User,
    adminMode: Boolean
  }
}
</script>
